var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPodcast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 19H11V22H38V19Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25C32 28.85 28.85 32 25 32H23C19.15 32 16 28.85 16 25V10C16 6.15 19.15 3 23 3H25C28.85 3 32 6.15 32 10V25Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41H26V36H22V41H17C16.448 41 16 41.448 16 42V44C16 44.552 16.448 45 17 45H31C31.552 45 32 44.552 32 44V42C32 41.448 31.552 41 31 41Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13H16V10H20.5C21.328 10 22 10.672 22 11.5C22 12.328 21.328 13 20.5 13Z",
    fill: "#6D7479"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19H16V16H20.5C21.328 16 22 16.672 22 17.5C22 18.328 21.328 19 20.5 19Z",
    fill: "#6D7479"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 25H16V22H20.5C21.328 22 22 22.672 22 23.5C22 24.328 21.328 25 20.5 25Z",
    fill: "#6D7479"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 22H32V25H27.5C26.672 25 26 24.328 26 23.5C26 22.672 26.672 22 27.5 22Z",
    fill: "#6D7479"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16H32V19H27.5C26.672 19 26 18.328 26 17.5C26 16.672 26.672 16 27.5 16Z",
    fill: "#6D7479"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 10H32V13H27.5C26.672 13 26 12.328 26 11.5C26 10.672 26.672 10 27.5 10Z",
    fill: "#6D7479"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.295 37.983C15.774 37.612 10 31.124 10 23.594V17C10 16.448 10.448 16 11 16H12C12.552 16 13 16.448 13 17V23.678C13 29.403 17.24 34.414 22.94 34.95C29.48 35.566 35 30.415 35 24V17C35 16.448 35.448 16 36 16H37C37.552 16 38 16.448 38 17V24C38 31.953 31.334 38.379 23.295 37.983Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24.5,
    y1: 12.392,
    x2: 24.5,
    y2: 26.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767D84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 19.852,
    y1: 3.933,
    x2: 28.625,
    y2: 32.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F959B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 24,
    y1: 37.738,
    x2: 24,
    y2: 44.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#656D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#727D86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 21.389,
    y1: 12.778,
    x2: 28.844,
    y2: 37.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767D84"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.35002f4af757e5b9c5ad19a9422b33ef.svg";
export { ForwardRef as ReactComponent };